export class Timer {
    
    startedTime: number = 0;
    timeout:any;

    time: number;
    initialTime: number;
    callback: any;

    running: boolean = false;
    
    constructor(callbackFunction: any, time: number) {
        this.time = time; 
        this.initialTime = time;
        this.callback = callbackFunction; 
        this.run(); // It will be automatically invoked when the constructor is run
    }
    run() {
        this.startedTime = new Date().getTime();

        // restart timer
        if(this.time < 0 && !this.running) {
            this.time = this.initialTime; 
        }

        if (!this.running && this.time > 0) {
            this.running = true;
            this.timeout = setTimeout(this.callback, this.time); // Timeout must be set if this.time is greater than 0
        }

    }
    pause() {
        let currentTime = new Date().getTime();
        this.time = this.time - (currentTime - this.startedTime); // The time that was given when initializing the timeout is subtracted from the amount of time spent
        if(this.running && this.timeout) {
            this.running = false;
            clearTimeout(this.timeout);
        }
    }
}
